const ajaxMainThemeUrlPrefix = document.location.origin + '/wp-content/themes/odds-scanner-main/ajax/';
const ajaxChildThemeUrlPrefix = document.location.origin + '/wp-content/themes/os-betting-child/ajax/';

// @Load
function onLoad() {
    smoothHref();
    stickyScrollHeader();
    // trackContentScroll();

    if (wp_search_archive) searchArchiveLayoutOnLoad();
}



//@Submit
function formSubmit(event, formIdentifier, formTypePostId) {
    if (event) event.preventDefault();

    jQuery('body').addClass('loading');

    const formDiv = jQuery(`#form-${formIdentifier}`);
    const formFields = formDiv.find('.field:not(.hide):not(:has(input[type="button"]))');

    formClean(formDiv);

    const formData = formGetData(formFields, formIdentifier, formTypePostId);

    const url = `${ajaxChildThemeUrlPrefix}forms.php`;

    jQuery.ajax({
        url: url,
        method: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        form_type_post_id: formTypePostId,
        success: function (data) {
            if (data.success) {
                formSuccess(formDiv, data.success);
            }
            else {
                formErrors(data.errors, formFields);
            }
        },
        dataType: 'json'
    })
        .always(function () {
            jQuery('body').removeClass('loading');
        });
}


//@Forms
function formPreventDefault(event) {
    event.preventDefault();
}

function formGetData(formFields, formIdentifier, formTypePostId) {
    const formData = new FormData();
    let submitAfterFill = 0;

    formData.append('wp_site_id', wp_site_id);
    formData.append('wp_post_id', wp_post_id);
    formData.append('form_identifier', formIdentifier);
    formData.append('form_type_post_id', formTypePostId);

    if (typeof form_os_source !== 'undefined' && form_os_source) formData.append('form_os_source', form_os_source);

    const fieldsData = {};

    formFields.each((index, field) => {
        const currentFieldDiv = jQuery(field);

        if (field.dataset.customFieldType == undefined) {
            const inputs = currentFieldDiv.find('textarea, input:not([type="checkbox"]), select, button'); // Checkbox has to be custom field

            if (inputs[0].type === 'submit') return true;
            if (inputs[0] && inputs[0].name && (inputs[0].name == 'password' || inputs[0].name == 'confirm-password' || inputs[0].name == 'current-password')) inputs[0].type = 'password'; // Making sure that password and confirm password fields types are password and not text because of show/hide password

            fieldsData[inputs[0].name] = {
                name: inputs[0].name,
                type: inputs[0].type,
                full_validate: inputs[0].dataset.fullValidate == 0 ? 0 : 1 // always 1 unless specified to be 0 
            }

            if (inputs[0].type == 'radio') {
                inputs.each((index, el) => {
                    if (el.checked) fieldsData[el.name].value = el.value;
                    else if (fieldsData[el.name].value == undefined) fieldsData[el.name].value = '';

                    if (el.required) fieldsData[el.name].required = el.required;
                    else if (fieldsData[el.name].required == undefined) fieldsData[el.name].required = false;
                })
            }
            else if (inputs[0].type == 'file') {
                formData.append(`attachment_${inputs[0].name}`, inputs[0].files[0]);

                fieldsData[inputs[0].name].value = inputs[0].files.length > 0 ? `attachment_${inputs[0].name}` : '';
                fieldsData[inputs[0].name].required = inputs[0].required;
                fieldsData[inputs[0].name].maximum_size = inputs[0].dataset.maximumSize ? Number(inputs[0].dataset.maximumSize) : '';
            }
            else if (inputs[0].type == 'select-multiple') {
                fieldsData[inputs[0].name].values = jQuery(inputs[0]).val();
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
            else if (inputs[0].type == 'tel') {
                fieldsData[inputs[0].name].country_code = inputs[0].dataset.countryCode;
                fieldsData[inputs[0].name].dialling_code = inputs[0].dataset.diallingCode;
                fieldsData[inputs[0].name].value = inputs[0].value;
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
            else {
                fieldsData[inputs[0].name].value = inputs[0].value;
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
        }
        else {
            fieldsData[field.dataset.customFieldName] = {
                name: field.dataset.customFieldName,
                type: field.dataset.customFieldType,
                required: field.dataset.customFieldRequired == 1 ? true : false
            }

            if (field.dataset.customFieldType == 'checkbox') {
                fieldsData[field.dataset.customFieldName].values = [];

                jQuery(field).find(':checked').each((index, el) => fieldsData[field.dataset.customFieldName].values.push(el.value));
            }
            else if (field.dataset.customFieldType == 'select-one' || field.dataset.customFieldType == 'date') fieldsData[field.dataset.customFieldName].value = field.dataset.customFieldValue;
            else if (field.dataset.customFieldType == 'select-multiple') fieldsData[field.dataset.customFieldName].values = field.dataset.customFieldValues ? field.dataset.customFieldValues.split(',') : [];
        }
    });

    if (jQuery('body').hasClass('testing')) console.log(fieldsData);

    formData.append('fields', JSON.stringify(fieldsData));

    return formData;
}

function formErrors(errors, formFields) {
    for (const [key, values] of Object.entries(errors)) {
        formFields.each((index, field) => {
            if ((field.dataset.customFieldType == undefined && jQuery(field).find('textarea, input:not([type="checkbox"]), select, button')[0].name == key) || field.dataset.customFieldName == key) {
                const errorDiv = jQuery(field).find('.error:not(input)');
                values.forEach(message => layoutHeading('span', message, null, errorDiv[0]));

                jQuery(field).find('input').addClass('error');
            }
        })
    }
}

function formClean(formDiv) {
    const errorFields = formDiv.find('.error');
    errorFields.each((index, field) => {
        const fieldErrors = jQuery(field).children();
        const parentErrors = jQuery(field).parent();

        if (fieldErrors.length > 0) fieldErrors.each((index, error) => jQuery(error).remove());
        if (parentErrors.length && parentErrors.hasClass('has-error')) parentErrors.removeClass('has-error');
    })

    const successDiv = formDiv.find('.success');
    if (successDiv.length > 0) {
        const successMessage = successDiv.children(':first');

        if (successMessage.length > 0) successMessage.remove();
    }
}

function formSuccess(formDiv, success) {
    if (success.action === 'redirect') location.replace(success.value);
    else if (success.action === 'success_message') formSuccessMessage(formDiv, success.value);
    else location.reload();
}

function formSuccessMessage(formDiv, successMessage) {
    const formElement = jQuery(formDiv).find('form');
    const successDiv = formDiv.find('.success');

    if (successDiv.length > 0) layoutHeading('span', successMessage.title, null, successDiv[0]);
    if (successMessage.icon) layoutImage(successMessage.icon, null, successDiv[0]);

    jQuery(formElement)[0].reset();

    setTimeout(() => { successDiv.children().remove(); }, 5000);
}


//@Search Bar
function searchBarCleanError(searchBarDiv) {
    const errorDiv = $(searchBarDiv).find('error');
}

function searchBarGetSearchQuery(element) {
    const inputDiv = jQuery(element).closest('.search-bar').find('input');
    return inputDiv[0].value.toLowerCase();
}

function handleSearchSubmit(event, element) {
    event.preventDefault();

    const searchBarDiv = $(element).closest('.search-bar');

    let searchQuery = searchBarGetSearchQuery(searchBarDiv);

    if (searchQuery.length >= 3) searchBarRedirect(searchBarDiv, searchQuery);
}

function searchBarRedirect(searchBarDiv, searchQuery) {
    const archivePageUrl = searchBarDiv.find('[data-archive-page-url]')[0].dataset.archivePageUrl;

    window.location.href = `${archivePageUrl}?search=${searchQuery}`;
}


//@Search Archive
function searchArchiveLayoutOnLoad() {
    const resultsWrapperDiv = $('.results-wrapper')[0];

    pagination.data.entries = pagination.data.entries.filter(wpPost => wpPost.name.toLowerCase().includes(pagination_current_filter.filter.search_query.toLowerCase()));
    pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

    if (pagination.data.entries.length == 0) searchArchiveLayoutNoResultsStyles(resultsWrapperDiv, pagination_current_filter, pagination_default_filter.search_styles);
    else searchArchiveLayoutResultsStyles(resultsWrapperDiv, pagination_current_filter, pagination.data.entries, pagination_default_filter.search_styles, pagination.styles);
}

function searchArchiveLayoutResultsStyles(parentDiv, paginationCurrentFilter, paginationDataEntries, searchStyles, paginationStyles) {
    paginationCurrentPage = paginationCurrentFilter.pagination.page;
    paginationEntriesPerPage = paginationCurrentFilter.pagination.entries_per_page * 1;
    paginationTotalEntries = paginationCurrentFilter.pagination.total_entries * 1;
    paginationSearchQuery = paginationCurrentFilter.filter.search_query || null;

    const resultsDiv = layoutElement('div', 'results', parentDiv);
    const cardsDiv = layoutElement('div', 'cards', resultsDiv);

    if (paginationSearchQuery) {
        const resultsCounterDiv = jQuery('section.hero .results-counter')[0];

        $(resultsCounterDiv).html(`
            <span>${paginationDataEntries.length} ${searchStyles.results_string} "<span class='colored'>${paginationSearchQuery}</span>"</span>
        `);
    }

    if (paginationDataEntries) {
        let startIndex = (paginationCurrentPage - 1) * paginationEntriesPerPage;
        const endIndex = (paginationCurrentPage * paginationEntriesPerPage) - 1;

        while (paginationDataEntries[startIndex] && startIndex <= endIndex) {
            createArticleVerticalMediumCard(paginationDataEntries[startIndex], cardsDiv);
            startIndex++;
        }

        if (paginationTotalEntries > paginationEntriesPerPage) searchArchiveLayoutResultsBottomStyles(resultsDiv, paginationEntriesPerPage, paginationTotalEntries, searchStyles, paginationStyles);
    }
}

function searchArchiveLayoutNoResultsStyles(parentDiv, paginationCurrentFilter, searchStyles) {
    paginationSearchQuery = paginationCurrentFilter.filter.search_query || null;

    const containerDiv = $(parentDiv).closest('.container')[0];
    const noResultsDiv = layoutElement('div', 'no-results', containerDiv);

    if(searchStyles.no_results_icon) {
        const iconDiv = layoutElement('div', 'icon', noResultsDiv);
        layoutImage(searchStyles.no_results_icon, null, iconDiv);
    }

    const titleDiv = layoutElement('div', 'title', noResultsDiv);
    layoutHeading(searchStyles.no_results_title.heading, `${searchStyles.no_results_title.title} "<span class='colored'>${paginationSearchQuery}</span>"`, null, titleDiv);

    const subtitleDiv = layoutElement('div', 'subtitle', noResultsDiv);
    layoutHeading('p', searchStyles.no_results_subtitle, null, subtitleDiv);
}

function searchArchiveLayoutResultsBottomStyles(parentDiv, entriesPerPage, totalEntries, searchStyles, paginationStyles) {
    const paginationDiv = layoutElement('div', 'pagination', parentDiv);

    searchArchiveLayoutPaginationStyles(paginationDiv, entriesPerPage, totalEntries, paginationStyles);
}

function searchArchiveLayoutPaginationStyles(parentDiv, entriesPerPage, totalEntries, paginationStyles) {
    let paginationTotalPages = getPaginationTotalPages(entriesPerPage, totalEntries);

    paginationDiv = layoutElement('div', 'pagination', parentDiv);

    divNavigationLeft = layoutElement('div', 'navigation left hide', paginationDiv);
    divNavigationLeft.dataset.navigation = -1;
    divNavigationLeft.addEventListener('click', event => actionPaginationNavigation(event.currentTarget, -1, 'search-archive'));
    layoutImage(paginationStyles['navigation_icon'], null, divNavigationLeft);


    divPages = layoutElement('div', 'pages', paginationDiv);

    divCurrentPageNumber = layoutElement('div', 'page number current', divPages);
    layoutHeading('span', 1, null, divCurrentPageNumber);

    for (let i = 2; i < 5; i++) {
        if (i > paginationTotalPages) break;
        divPageNumber = layoutElement('div', 'page number', divPages);
        divPageNumber.dataset.page = i;
        divPageNumber.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, i, 'search-archive'));
        layoutHeading('span', i, null, divPageNumber);
    }

    if (paginationTotalPages > 5) {
        divPageDots = layoutElement('div', 'page dots', divPages);
        layoutHeading('span', '...', null, divPageDots);


        divPageNumber = layoutElement('div', 'page number', divPages);
        divPageNumber.dataset.page = paginationTotalPages;
        divPageNumber.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, paginationTotalPages, 'search-archive'));
        layoutHeading('span', paginationTotalPages, null, divPageNumber);
    }

    if (paginationTotalPages > 1) {
        divNavigationRight = layoutElement('div', 'navigation right', paginationDiv);
        divNavigationRight.dataset.navigation = +1;
        divNavigationRight.addEventListener('click', event => actionPaginationNavigation(event.currentTarget, +1, 'search-archive'));
        layoutImage(paginationStyles['navigation_icon'], null, divNavigationRight);
    }
}


// @Pagination Search
function handleSearchArchivePaginationEntries(paginationDiv, data) {
    const cardsDiv = jQuery('.results > .cards');
    cardsDiv.children().each((index, el) => jQuery(el).remove());

    if (data.entries) {
        let startIndex = (pagination_current_filter.pagination.page - 1) * pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = (pagination_current_filter.pagination.page * pagination_current_filter['pagination']['entries_per_page']) - 1;

        while (data.entries[startIndex] && startIndex <= endIndex) {
            createArticleVerticalMediumCard(data.entries[startIndex], cardsDiv[0]);

            startIndex++;
        }

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');
    }
}

function requestSearchArchivePaginationEntries() {
    const paginationDiv = jQuery('.results .pagination');

    handleSearchArchivePaginationEntries(paginationDiv, pagination.data);

    handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');
}


// @Pagination
function getPaginationTotalPages(entriesPerPage, totalEntries) {
    if (!entriesPerPage || !totalEntries) return 1;

    return Math.ceil(totalEntries / entriesPerPage);
}

function actionPaginationNavigation(element, action, template = null) {
    // Limit conditions
    pagination_current_filter['pagination']['page'] += action;

    requestSearchArchivePaginationEntries();
}

function handlePaginationPageSelect(element, page, template = null) {
    if (jQuery(element).hasClass('current')) return;

    pagination_current_filter['pagination']['page'] = page;

    requestSearchArchivePaginationEntries();
}

function handlePaginationStyle(paginationDiv, currentPage, totalPages, icon = null, navigationCallback = null, pageCallback = null, template = null) {
    let navigationFirstIconDiv = paginationDiv.find('.navigation.first');
    let navigationLastIconDiv = paginationDiv.find('.navigation.last');

    let navigationLeftIconDiv = paginationDiv.find('.navigation.left');
    if (navigationLeftIconDiv.length == 0) {
        navigationLeftIconDiv = layoutElement('div', 'navigation left', paginationDiv[0]);
        navigationLeftIconDiv.addEventListener('click', event => window[navigationCallback](event.currentTarget, -1, template));
        layoutImage(icon, null, navigationLeftIconDiv);

        navigationLeftIconDiv = jQuery(navigationLeftIconDiv);
    }
    else navigationLeftIconDiv.toggleClass('hide');

    if (currentPage != 1) {
        navigationLeftIconDiv.removeClass('hide');
        navigationFirstIconDiv.removeClass('hide');
    }
    else {
        navigationLeftIconDiv.addClass('hide');
        navigationFirstIconDiv.addClass('hide');
    }

    let pagesDiv = paginationDiv.find('.pages');
    if (pagesDiv.length == 0) pagesDiv = jQuery(layoutElement('div', 'pages', paginationDiv[0]));
    pagesDiv.children().each((index, el) => jQuery(el).remove());

    let pageNumberDiv = null;
    let pageDotsDiv = null;

    if (currentPage != 1) {
        pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
        pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, 1, template));
        layoutTitle('span', 1, null, null, pageNumberDiv);
    }

    if (currentPage > 4) {
        pageDotsDiv = layoutElement('div', 'page dots', pagesDiv[0]);
        layoutHeading('span', '...', null, pageDotsDiv);
    }

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
        if (i == currentPage) {
            pageNumberDiv = layoutElement('div', 'page number current', pagesDiv[0]);
            layoutHeading('span', i, null, pageNumberDiv);
        } else if (i > 1 && i < totalPages) {
            pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
            pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, i, template));
            layoutHeading('span', i, null, pageNumberDiv);
        }
    }

    if (currentPage < totalPages - 3) {
        pageDotsDiv = layoutElement('div', 'page dots', pagesDiv[0]);
        layoutHeading('span', '...', null, pageDotsDiv);
    }

    if (currentPage != totalPages) {
        pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
        pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, totalPages, template));
        layoutHeading('span', totalPages, null, pageNumberDiv);
    }

    let navigationRightIconDiv = paginationDiv.find('.navigation.right');
    if (navigationRightIconDiv.length == 0) {
        navigationRightIconDiv = layoutElement('div', 'navigation right', paginationDiv[0]);
        navigationRightIconDiv.addEventListener('click', event => window[navigationCallback](event.currentTarget, 1, template));

        layoutImage(icon, null, navigationRightIconDiv);

        navigationRightIconDiv = jQuery(navigationRightIconDiv);
    }

    if (currentPage != totalPages) {
        navigationRightIconDiv.removeClass('hide');
        navigationLastIconDiv.removeClass('hide');
    }
    else {
        navigationRightIconDiv.addClass('hide');
        navigationLastIconDiv.addClass('hide');
    }
}


// @Articles
function createArticleVerticalMediumCard(article, parentDiv) {
    const articleDiv = layoutElement('div', 'article vertical medium card variant-default', parentDiv);

    layoutButton(article.link, null, null, null, 'area-link', articleDiv);

    const topDiv = layoutElement('div', 'top', articleDiv);

    if (article.category_tag) {
        layoutButton(article.category_tag.link, 'span', article.category_tag.title, null, 'tag', topDiv);
    }

    const featuredImage = article.featured_image ?? article.default_featured_image;

    const featuredImageDiv = layoutElement('div', 'featured-image', topDiv);
    featuredImageDiv.style.backgroundImage = `url(${featuredImage.url})`;

    const bottomDiv = layoutElement('div', 'bottom', articleDiv);

    const titleDiv = layoutElement('div', 'title', bottomDiv);
    layoutButton(article.link, 'span', article.title, null, null, titleDiv);

    const metaDiv = layoutElement('div', 'meta', bottomDiv);

    const authorDiv = layoutElement('div', 'author', metaDiv);
    layoutHeading('span', article.wp_author.display_name, 'name', authorDiv);

    const bulletDiv = layoutElement('div', 'bullet', metaDiv);
    layoutHeading('span', '•', 'name', bulletDiv);

    const updatedDateDiv = layoutElement('div', 'updated-date', metaDiv);
    layoutHeading('span', article.updated_date_string, 'name', updatedDateDiv);
}


// @Toggle
function toggleSearch(element) {
    const status = element.dataset.status;
    const searchBar = $('.header-container').find('.search-bar');

    if (status === '0') {
        element.dataset.status = '1';
        searchBar[0].dataset.status = '1';
    }
    else {
        element.dataset.status = '0';
        searchBar[0].dataset.status = '0';
    }

    $(element).toggleClass('show');
    if (searchBar.length) $(searchBar).toggleClass('show');
}

function toggleSidenav() {
    const btnToggle = $('.header-container').find('.btn-toggle.sidemenu')[0];
    const sideNav = $('.side-nav');

    const status = btnToggle.dataset.status;

    if (status === '0') sideNav[0].dataset.status = '1';
    else sideNav[0].dataset.status = '0';

    if (sideNav.length) $(sideNav).toggleClass('show');
}

function toggleSidenavOnClickOutside(event) {
    if (event.target && (event.target == event.currentTarget)) toggleSidenav();
}


// @Scroll
function stickyScrollHeader() {
    const header = $('.header-container');

    if (!header.length) return;

    let lastScrollTop = 0;
    const threshold = 8;

    $(window).on('scroll', function () {
        const st = $(this).scrollTop();

        if (st > lastScrollTop + threshold && st > 80) {
            $(header).addClass('header-hidden');
        } else if (st < lastScrollTop - threshold) {
            $(header).removeClass('header-hidden');
        }

        lastScrollTop = st;
    });
}


// @Menu
function toggleSubmenu(element, toggleClass) {
    jQuery(element).parent().parent().toggleClass(toggleClass);
}


// @Limits Table
function showMoreLimitsTable(element) {

    jQuery(element).closest('table').removeClass('closed');
    jQuery(element).parent().parent().next().removeClass('closed');
}

function showLessLimitsTable(element) {

    jQuery(element).closest('table').addClass('closed');
    jQuery(element).parent().parent().prev('table').addClass('closed');
}


/** OS Main Function */

// @FAQs
function toggleFaq(element) {
    var current_faq_card = jQuery(element).parent();
    var content_block = current_faq_card.parent();
    var faq_cards = content_block[0].children;

    for (var i = 0; i < faq_cards.length; i++) {
        if (faq_cards[i] == current_faq_card[0]) {
            current_faq_card.toggleClass('open');
            current_faq_card.toggleClass('close');
        }
        else {
            jQuery(faq_cards[i]).removeClass('open');
            jQuery(faq_cards[i]).addClass('close');
        }
    }
}


// @Style
function smoothHref() {
    jQuery('[href*="#"]').click(function (e) {
        e.preventDefault();

        var url = this.href;
        var url_array = url.split('#');

        if (url_array[1] != '') {
            jQuery('html, body').animate({
                scrollTop: jQuery(jQuery('#' + url_array[url_array.length - 1]).offset().top)[0] - 5
            }, 500);
        }
    });
}


// @Layout
function layoutElement(tag, css_class, parent) {
    var element = document.createElement(tag);

    if (css_class !== null) element.className = css_class;

    parent.appendChild(element);

    return element;
}

function layoutImage(img_array, css_class, parent) {
    if (img_array === null) return;

    var img = document.createElement('img');

    if (css_class !== null) img.className = css_class;
    img.src = img_array['url'];
    img.alt = img_array['alt'];

    parent.appendChild(img);

    return img;
}

function layoutHeading(heading, title, css_class, parent) {
    if (title === null) return;

    var heading = document.createElement(heading);

    heading.innerHTML = title;
    if (css_class !== null) heading.className = css_class;

    parent.appendChild(heading);

    return heading;
}

function layoutTitle(heading, title, icon, css_class, parent) {
    if (title === null && icon !== null) return layoutImage(icon, css_class, parent);
    if (title !== null && icon === null) return layoutHeading(heading, title, css_class, parent);
    if (title === null && icon === null) return;

    var div = document.createElement('div');

    if (css_class !== null) div.className = css_class;

    layoutHeading(heading, title, '', div);
    layoutImage(icon, '', div);

    parent.appendChild(div);

    return div;

}

function layoutButton(link, heading, title, icon, css_class, parent, target = null, rel = null) {
    if (link === null) return layoutTitle(heading, title, icon, css_class, parent);

    var a = document.createElement('a');

    if (css_class !== null) a.className = css_class;
    a.href = link['url'];
    a.title = link['title'];
    if (target !== null) a.target = target;
    if (rel !== null) a.rel = rel;

    if (title !== null) layoutHeading(heading, title, '', a);

    if (icon !== null) layoutImage(icon, '', a);

    parent.appendChild(a);

    return a;
}

function layoutScript(url, parent) {
    var script = document.createElement('script');
    script.src = url;

    parent.appendChild(script);
}


// @Cookies
function setCookie(cname, cvalue, seconds) {
    if (seconds) {
        var d = new Date();
        d.setTime(d.getTime() + (seconds * 1000));
        var expires = 'expires=' + d.toUTCString();

        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    else document.cookie = cname + '=' + cvalue + ';path=/';
}

function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }

    return '';
}

function checkCookie(new_identifier, time) {
    var identifier = getCookie(new_identifier);

    if (identifier != '') return false;
    else if (new_identifier != '' && new_identifier != null) {
        setCookie(new_identifier, new_identifier, time);

        return true;
    }
}

function deleteCookie(cname) {
    setCookie(cname, '', -1);
}


// @Show More
function actionShowMore(element) {
    const parent = jQuery(element).parent();
    const cards = jQuery(parent).find('.cards');

    jQuery(cards).find('> .hide:lt(5)').removeClass('hide');

    const hiddenCount = jQuery(cards).find('.card.hide').length;

    if (hiddenCount === 0) {
        jQuery('.advertisers .show-more').addClass('hide');
    }
}


// @Show More/Less
function actionShowMoreLessContent(element) {
    var children = jQuery(element).parent().children();

    for (var i = 0; i < children.length; i++) jQuery(children[i]).toggleClass('hide');
}


// @Copy To Clipboard
function copyToClipboard(element, text) {
    const copyToClipboardDiv = jQuery(element).closest('.copy-to-clipboard');

    if (copyToClipboardDiv.hasClass('active')) return;

    copyToClipboardDiv.addClass('active');

    navigator.clipboard.writeText(text);

    setTimeout(() => {
        copyToClipboardDiv.removeClass('active');
    }, 2000);
}


// @Content Navigation
function actionActiveContentNavigationItem(element, event) {
    event.stopPropagation();

    const $currentElement = jQuery(element);

    if ($currentElement.hasClass('active')) return;

    $currentElement.closest('.navigation').find('li').removeClass('active');
    $currentElement.addClass('active');
}

let currentHeadingIndex = 0;
function trackContentScroll() {
    if (jQuery('.widget-content-navigation').length > 0) {
        let headingsHeightArray = [];

        const contentBlockHeadings = jQuery('.content h2');
        contentBlockHeadings.each(function () {
            headingsHeightArray.push(jQuery(this).offset().top - 800);
        });

        jQuery(window).scroll(function (e) {

            if (!(jQuery(this).is(':animated'))) {

                const height = jQuery(window).scrollTop();

                for (let i = 0; i < headingsHeightArray.length; i++) {

                    if (height > headingsHeightArray[i] + 250) {

                        if (i != currentHeadingIndex) {
                            jQuery('.widget-content-navigation ul li').each(function () { if (jQuery(this).hasClass('active')) jQuery(this).removeClass('active') })
                            jQuery('.widget-content-navigation ul li').eq(i).addClass('active');
                        }

                        currentHeadingIndex = i;
                    }
                }
            }
        });
    }
}


//@Iframe
function displayIframeOnClick(element, iframe_source, css_class, js_source, iframe_id) {
    const iframe_cover = $(element).closest('.iframe-cover');

    css_class = css_class !== null ? `h_iframe ${css_class}` : 'h_iframe default';

    $(iframe_cover).empty();
    $(iframe_cover).attr('class', css_class);

    $html = '';

    if (js_source !== null) {
        $html += `<script id='js_source' src='${js_source}'></script>`;
    }

    $html += `
        <iframe
        ${iframe_id !== null ? `id="${iframe_id}"` : ''}
        src='${iframe_source}'
        frameborder='0' allowfullscreen='allowfullscreen' loading='lazy' fetchpriority='low'>
        </iframe>
    `;

    $(iframe_cover).html($html);
}
